import { gql } from "@apollo/client";

export const GENERATE_COMPANY_PROFILE_FROM_UPLOADS = gql`
  mutation GenerateCompanyProfileFromUploads($companyId: String!, $useExistingProfile: Boolean) {
    generateCompanyProfileFromUploads(companyId: $companyId, useExistingProfile: $useExistingProfile)
  }
`; 